/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Action, Column, Options } from '@infotrack/presentacion-componentes/tabla';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IFabricantes from 'Infotrack@Modelos/smartStock/fabricantes/entidades/fabricantes';
import { BotonAgregar, BotonRefrescar } from 'Infotrack@Transversales/componentes/botonesAcciones';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const columnas = (
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string
): Array<Column<IFabricantes>> => [
    {
        title: formatMessage({ id: 'fabricantes.fabricanteDescripcion' }),
        field: 'FabricanteDescripcion',
    },
    {
        title: formatMessage({ id: 'productos.estado' }),
        field: 'Estado',
        type: 'boolean',
    },
];

export const acciones = (
    manejarFormulario: (tipoFormulario: TipoFormulario, fabricantes?: IFabricantes) => void,
    cargarFabricantes: () => void,
    formatMessage: (params: FormattedMessage.MessageDescriptor) => string,
    confirmarEliminacion: (fabricantes: IFabricantes) => void
): Array<Action<IFabricantes>> => [
    {
        icon: 'refresh',
        onClick: cargarFabricantes,
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.refrescar' }),
    },
    {
        icon: 'add',
        onClick: () => manejarFormulario(TipoFormulario.Creacion, undefined),
        isFreeAction: true,
        tooltip: formatMessage({ id: 'boton.agregar' }),
    },
    {
        icon: () => <EditIcon id="Icono-Editar" color="action" />,
        onClick: (_, value) => manejarFormulario(TipoFormulario.Edicion, value as IFabricantes),
        tooltip: formatMessage({ id: 'boton.editar' }),
    },

    {
        icon: () => <DeleteIcon id="Icono-Eliminar" color="action" />,
        onClick: (_, value) => confirmarEliminacion(value as IFabricantes),
        tooltip: formatMessage({ id: 'boton.eliminar' }),
    },
];

export const opciones: Options<IFabricantes> = {
    maxBodyHeight: '50vh',
};
